import { useMutation } from '@tanstack/react-query'
import { useAPI } from '../../../Contexts/APIContext'
import successToast from '../../../Components/Toasts/SuccessToast'
import errorToast from '../../../Components/Toasts/ErrorToast'
import useAccessLevel from './useAccessLevel'

export function useResendInvite({ o_f_id }) {
  const { resendOrganizationInvite } = useAPI()
  const { isInternalAdmin, hasOrgAdminAccess } = useAccessLevel({ o_f_id })

  const { mutate } = useMutation({
    mutationFn: ({ email }) => resendOrganizationInvite({ email }),
    onSuccess: () => {
      successToast('Invite email sent')
    },
    onError: error => {
      if (error?.status === 403) {
        errorToast('You do not have permission to resend invites')
      } else if (error?.status === 404) {
        errorToast('Organization not found')
      } else {
        errorToast('Error sending invite')
      }
    },
  })

  const canResendInvite = isInternalAdmin || hasOrgAdminAccess

  return { resendInvite: mutate, canResendInvite }
}
